
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';

  @Component({})
  export default class SendButton extends Vue {
    @Prop({required: false, default: 'buttons.send'}) label!: string;
    @Prop({required: false, default: 'fas fa-paper-plane'}) icon!: string;
    @Prop({required: false, default: false}) disabled!: boolean;
    @Prop({required: false, default: false}) loading!: boolean;

    @Emit()
    onClick() {
      return;
    }
  }
